import React from 'react';

import { LaptopSolidIcon } from '../../shared/icons/icons';
import Flag from '../flag/flag';

import './web-only-flag.scss';

interface WebOnlyFlagProps {
  className?: string;
  hideLabel?: boolean;
}

function WebOnlyFlag(props: WebOnlyFlagProps) {
  const { className = '', hideLabel = false } = props;

  return (
    <Flag
      className={`web-only-flag ${className}`}
      key="web-only"
      renderIcon={
        <LaptopSolidIcon
          className="web-only-flag__flag-icon"
          styleName="flag-icon"
        />
      }
      styleName="flag"
    >
      {!hideLabel ? 'ONLINE ONLY' : ''}
    </Flag>
  );
}

export default WebOnlyFlag;
